require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-mantra-collective-civic-underground.json") })
        }
      }, "path---interview-mantra-collective-civic-underground");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-mantra-collective-civic-underground!./.cache/json/interview-mantra-collective-civic-underground.json
// module id = 690
// module chunks = 231608221292675